export const ONBOARDING_GOOGLE_EVENTS = {
	QUIZ_PASSED: 'onboarding_passed',
	FIRST_PAGE_PASSED: 'landing_passed',
	PAY_PRESSED: 'pay_pressed',
	EMAIL_COMPLETED: 'email_completed',
	SUBSCRIPTION_SHOWN: 'subscription_shown',
	SUBSCRIPTION_CONTINUE: 'subscription_continue',
	PURCHASE: 'purchase',
};
